<template>
  <div id="weather">
      <div class="image" v-if="item.imagePath"><img :src="item.imagePath"></div>
      
      <div class="block temperature">
        <p class="heading">Outside</p>
        <div class="value" v-if="item.temperature">{{ item.temperature.value }}&deg;</div>
      </div>

      <div class="block precipitation" v-if="item.precipitation">
        <p class="heading">Precipitation</p>
        <div class="value">{{ item.precipitation.value }}mm</div>
      </div>

      <current-time :show-seconds="false"></current-time>
      <!--<p>{{credit.text}}</p>-->
  </div>
</template>

<script>
import axios from 'axios'
import CurrentTime from './Shared/CurrentTime.vue'

export default {
  props: {
    iconSize: {
      type: Number,
      default: 200
    }
  },
  data () {
    return {
      pollingRate: 60000*5,
      interval: null,
      cachedData: [],
      credit: {},
      item: {
        temperature: {},
        precipitation: {},
        imagePath: ''
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
    this.interval = null
  },
  mounted () {
    this.loadData()
    this.interval = setInterval(() => {
      this.loadData()
    }, this.pollingRate)
  },
  methods: {
    loadData () {
      // Caching response in db for 60 minutes
      axios.get(`https://gate01.se/api/weather/read_one.php`)
        .then(response => {
          if (response && response.data) {
            this.cachedData = response.data
            var item = this.parseItems(response.data)[0];       
            if (!item) item = this.generateEmptyItem();
            this.setItem(item);
          }
        }).catch(() => {
          if (this.cachedData) {
            var item = this.parseItems(this.cachedData)[0];
            if (!item) item = this.generateEmptyItem();
            this.setItem(item);
          }
        })
    }, 
    generateEmptyItem() {
      this.credit.text = "Weather forecast is currently offline.";
      return {
        temperature: { value: null },
        precipitation: { value: null },
        imagePath: null
      }
    },
    parseItems(data) {
      // https://developer.yr.no/doc/GettingStarted/
      data = JSON.parse(data);

      var items = [];
      if (data && data.properties && data.properties.timeseries) {
        items = data.properties.timeseries.filter(this.closestHourFilter).map(item => {
          return {
            temperature: { "value": Math.floor(item.data.instant.details.air_temperature) },
            precipitation: { "value": (item.data.next_1_hours) ? Math.floor(item.data.next_1_hours.details.precipitation_amount) : '' },
            imagePath: (item.data.next_1_hours) ? `https://gate01.se/api/weather/weathericon/png/${ item.data.next_1_hours.summary.symbol_code }.png` : ''
          } 
        })
      }
      return items;
    },
    setItem (item) {
      this.item = item;
    },
    closestHourFilter (item) {
      var close = new Date() < new Date(item.time);
      // console.log(new Date() + '<' + new Date(item.time), close);
      return close;
    }
  },
  components: {
    CurrentTime
  }
}
</script>

<style lang="scss">
  #weather {
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    text-align: center;
    padding: 0 2em 0 0;

    > * {
      flex-grow: 1;
    }

    .image {
      img {
        height: 115px;
        margin-top: 20px;
      }
    } 

    .block {
      .heading {
        font-size: 2rem;
        margin: 0;
        padding: 0;
        text-transform: uppercase;
      }

      .value {
        font-family: 'Paytone One';
        font-size: 4rem;
        font-weight: 400;
        letter-spacing: 2px;
        line-height: 5rem;
      }
    }

    .current-time {
        margin-bottom: 0;
        .line-through::before {
            border: 0;
        }
        .datetime {
            width: auto;

            .time {
              line-height: 5rem;
            }
        }
    }
  }
</style>
